<div class="home renaissance-style-scoped" aria-labelledby="skip-nav">
  <h1 class="sr-only" tabindex="-1">{{teacherJourneyText}}</h1>
  <router-outlet></router-outlet>
</div>
